import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentMultiReturnVerifyPhoneData,
  type EnrollmentMultiReturnVerifyPhoneSubmitOutput,
  type EnrollmentMultiVerifyPhoneContinueApplicationOutput,
} from '../../../../models/enrollment/multi/return-verify-phone'

export const getEnrollmentMultiReturnVerifyPhoneDataMock: EnrollmentMultiReturnVerifyPhoneData = {
  nextStep: 'VERIFY_PHONE',
  error: null,
  phone: {
    countryPhoneCode: '+1',
    phoneNumber: '1234567890',
  },
}

export const submitEnrollmentMultiReturnVerifyPhoneDataMock: EnrollmentMultiReturnVerifyPhoneSubmitOutput = {
  enrollmentType: 'INDIVIDUAL',
  nextStep: 'SESSION_RESTORED',
  error: null,
  phone: {
    countryPhoneCode: '+1',
    phoneNumber: '1234567890',
  },
}

export const submitEnrollmentMultiResendReturnVerifyPhoneDataMock: EnrollmentMultiReturnVerifyPhoneSubmitOutput = {
  enrollmentType: 'INDIVIDUAL',
  nextStep: 'VERIFY_PHONE',
  error: null,
  phone: {
    countryPhoneCode: '+1',
    phoneNumber: '1234567890',
  },
}

export const submitEnrollmentMultiReturnVerifyPhoneOtpDataMock: EnrollmentMultiVerifyPhoneContinueApplicationOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/next-step',
}

export const mockGetEnrollmentMultiReturnVerifyPhoneData = graphql.mutation(
  'getEnrollmentMultiReturnVerifyPhoneData',
  () => {
    return HttpResponse.json({ data: { enterApplication: getEnrollmentMultiReturnVerifyPhoneDataMock } })
  },
)

export const mockSubmitEnrollmentMultiReturnVerifyPhoneData = graphql.mutation(
  'submitEnrollmentMultiReturnVerifyPhoneData',
  () => {
    return HttpResponse.json({ data: { enterApplication: submitEnrollmentMultiReturnVerifyPhoneDataMock } })
  },
)

export const mockSubmitEnrollmentMultiResendReturnVerifyPhoneData = graphql.mutation(
  'submitEnrollmentMultiResendReturnVerifyPhoneData',
  () => {
    return HttpResponse.json({ data: { enterApplication: submitEnrollmentMultiResendReturnVerifyPhoneDataMock } })
  },
)

export const mockSubmitEnrollmentMultiReturnVerifyPhoneOtpData = graphql.mutation(
  'submitEnrollmentVerifyPhoneData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiReturnVerifyPhoneOtpDataMock } })
  },
)

export const mockEnrollmentMultiReturnVerifyPhone = [
  mockGetEnrollmentMultiReturnVerifyPhoneData,
  mockSubmitEnrollmentMultiReturnVerifyPhoneData,
  mockSubmitEnrollmentMultiResendReturnVerifyPhoneData,
  mockSubmitEnrollmentMultiReturnVerifyPhoneOtpData,
]
